import Screen from "controllers/Screen";
import * as PIXI from 'lib/pixi.js'
import AbstractHeader from "components/partials/interactive-header/js/AbstractHeader";
import Easing from "utils/Easing";
import TransitionController from "controllers/TransitionController";
import Scroll from "../../../../assets/src/js/app/controllers/Scroll";


export default class ContactHeader extends AbstractHeader {
	constructor($wrapper) {
		super($wrapper);

		MorphSVGPlugin.defaultUpdateTarget = false;
		MorphSVGPlugin.defaultRender = null;

		this.numBlobs = 6;
		this.shapeWidth = 1500;
		this.shapeHeight = 950;
		this.blobDuration = 10;
		this.scale = this.realHeight / this.shapeHeight;


		this.init();
	}

	initDOM() {
		// Content
		this.$content = this.$wrapper.closest('.page_container').find('.page_content');

		// Empty faces
		this.$faceLeft = $('#face_left');
		this.$faceRight = $('#face_right');

		// Empty blobs
		this.$blobLeft = $('#blob_left');
		this.$blobRight = $('#blob_right');

		// All the shapes
		this.$leftBlob = $('#left_blob');
		this.$leftStart = $('#left_start');
		this.$leftEnd = $('#left_end');
		this.$rightBlob = $('#right_blob');
		this.$rightStart = $('#right_start');
		this.$rightEnd = $('#right_end');
	}

	initEl() {
		super.initEl();

		this.$faceLeft.attr('d', this.$leftStart.attr('d'));
		this.$faceRight.attr('d', this.$rightStart.attr('d'));

		this.$blobLeft.attr('d', this.$leftStart.attr('d'));
		this.$blobRight.attr('d', this.$rightStart.attr('d'));

		// BLOBS
		this.pxBlobs = new PIXI.Container();
		// this.pxBlobs.sortableChildren = true;
		this.pxBlobsGraphics = {
			'left': [],
			'right': [],
		};
		for (let i = 0; i < this.numBlobs; i++) {
			const left = new PIXI.Graphics();
			this.pxBlobs.addChildAt(left, 0);
			this.pxBlobsGraphics['left'].push(left);

			const right = new PIXI.Graphics();
			this.pxBlobs.addChildAt(right, 0);
			this.pxBlobsGraphics['right'].push(right);

		}
		this.pxShape.addChild(this.pxBlobs);

		// FACES
		this.pxFaces = new PIXI.Container();
		this.pxFacesGraphics = {
			'left': new PIXI.Graphics(),
			'right': new PIXI.Graphics(),
		};
		this.pxFaces.addChild(this.pxFacesGraphics.left);
		this.pxFaces.addChild(this.pxFacesGraphics.right);
		this.app.stage.addChild(this.pxFaces);
	}

	bindEvents() {
		// TransitionController.once(TransitionController.E.TRANSITION_COMPLETE, this.resize, this);
		super.bindEvents();
	}


	raf() {
		super.raf();
		if (this.isVisible) {
			this.scrollPercent = Easing.easeOutQuint(Math.min(Scroll.yI / this.virtualHeight * 1.25, 1));
			this.tw['faceleft'].progress(this.scrollPercent);
			this.tw['faceright'].progress(this.scrollPercent);
		}
	}


	resize(isMobileH) {

		if (isMobileH) {
			return;
		}

		this.realHeight = this.$wrapper.height();
		this.virtualHeight = this.$content.height();
		this.scale = this.realHeight / this.shapeHeight;
		this.updateShapes();
		// super.resize(isMobileH);


	}

	// Override
	checkScroll() {
	}


	updateShapes() {
		this.updateBlob('left');
		this.updateBlob('right');
		this.updateFace('left');
		this.updateFace('right');
	}

	updateBlob(side) {
		const $target = side === 'left' ? this.$blobLeft : this.$blobRight;
		for (let i = 0; i < this.numBlobs; i++) {

			// Maybe kill existing tween
			if (this.tw['blob' + side + '-' + i]) {
				this.tw['blob' + side + '-' + i].progress(0, true).kill();
			}

			// Reset child index
			this.pxBlobsGraphics[side][i].clear();
			this.pxBlobs.setChildIndex(this.pxBlobsGraphics[side][i], (this.numBlobs - i) * 2 - ((side === 'left') ? 1 : 2));

			// Sets the tween
			this.tw['blob' + side + '-' + i] = gsap.to($target, {
				duration: this.blobDuration,
				ease: 'none',
				repeat: -1,
				morphSVG: {
					shapeIndex: side === "left" ? -15 : 22, // Auto calculated
					// shapeIndex: side === "left" ? -17 : 22, // Manual
					shape: side === 'left' ? this.$leftBlob : this.$rightBlob,
					render: (rawPath) => {
						this.drawBlob(this.tw['blob' + side + '-' + i].progress(), side, this.pxBlobsGraphics[side][i], rawPath);
					}
				},
				onRepeat: () => {
					this.pxBlobs.setChildIndex(this.pxBlobsGraphics[side][i], this.numBlobs * 2 - ((side === 'left') ? 1 : 2));
				}
			});
			this.tw['blob' + side + '-' + i].progress(i / this.numBlobs, true);
		}
	}

	updateFace(side) {
		const $target = side === 'left' ? this.$faceLeft : this.$faceRight;

		// Maybe kill existing tween
		if (this.tw['face' + side]) {
			this.tw['face' + side].progress(0, true).kill();
		}

		// Reset shape
		this.pxFacesGraphics[side].clear();

		// Sets the tween
		this.tw['face' + side] = gsap.to($target, {
			paused: true,
			ease: 'none',
			morphSVG: {
				shape: side === 'left' ? this.$leftEnd : this.$rightEnd,
				render: (rawPath) => {
					this.drawFace(side, this.pxFacesGraphics[side], rawPath);
				}
			}
		});
	}

	drawBlob(progress, side, shape, rawPath) {

		// Shape
		shape.clear();

		const blobPercent = 1 - progress,
			finalScale = this.scale + progress,
			sWidth = this.shapeWidth * finalScale,
			sHeight = this.shapeHeight * finalScale;

		// COLOR
		const colorRG = 32 + (Easing.easeInQuad(blobPercent * this.introAlpha) * (43 - 32)),
			colorB = 32 + (Easing.easeInQuad(blobPercent * this.introAlpha) * (226 - 32));
		shape.beginFill(PIXI.utils.rgb2hex([colorRG / 255, colorRG / 255, colorB / 255]));

		// TRANSLATE
		if (side === 'left') {
			shape.x = (Screen.wW / 2) - sWidth + (sWidth / 23 * this.scrollPercent) - (Screen.wW / 10 * (1 - this.scrollPercent)) + (progress * (Screen.wW / 3));
		} else {
			shape.x = (Screen.wW / 2) - (sWidth / 23 * this.scrollPercent) + (Screen.wW / 10 * (1 - this.scrollPercent)) - (progress * (Screen.wW / 3));
		}
		shape.y = (this.realHeight / 2) - (sHeight / 2) - (this.realHeight / 2 * this.scrollPercent * progress);


		// SCALE
		shape.scale.set(finalScale, finalScale);

		let segment;
		for (let j = 0; j < rawPath.length; j++) {
			segment = rawPath[j];
			shape.moveTo(segment[0], segment[1]);
			for (let i = 2; i < segment.length; i += 6) {
				shape.bezierCurveTo(segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5]);
			}
			if (segment.closed) {
				shape.closePath();
			}
		}
		shape.endFill();
	}

	drawFace(side, shape, rawPath) {
		let l, segment, j, i;

		// Shape
		shape.clear();


		const sWidth = this.shapeWidth * this.scale,
			sHeight = this.shapeHeight * this.scale;

		// TRANSLATE
		// shape.beginFill(0x2b2be2);
		if (side === 'left') {
			const colorRG = 32 + (Easing.easeInQuad(this.introAlpha) * (43 - 32)),
				colorB = 32 + (Easing.easeInQuad(this.introAlpha) * (226 - 32));
			shape.beginFill(PIXI.utils.rgb2hex([colorRG / 255, colorRG / 255, colorB / 255]));
			shape.x = (Screen.wW / 2) - (sWidth / 2) - (sWidth / 2) + (sWidth / 23 * this.scrollPercent) - (Screen.wW / 10 * (1 - this.scrollPercent));
			shape.y = (this.realHeight / 2) - (sHeight / 2);
		} else {
			const colorR = 32 + (Easing.easeInQuad(this.introAlpha) * (60 - 32)),
				colorG = 32 + (Easing.easeInQuad(this.introAlpha) * (43 - 32)),
				colorB = 32 + (Easing.easeInQuad(this.introAlpha) * (226 - 32));
			shape.beginFill(PIXI.utils.rgb2hex([colorR / 255, colorG / 255, colorB / 255]));
			shape.x = (Screen.wW / 2) - (sWidth / 23 * this.scrollPercent) + (Screen.wW / 10 * (1 - this.scrollPercent));
			shape.y = (this.realHeight / 2) - (sHeight / 2);
		}

		// SCALE
		shape.scale.set(this.scale, this.scale);

		for (j = 0; j < rawPath.length; j++) {
			segment = rawPath[j];
			l = segment.length;
			shape.moveTo(segment[0], segment[1]);
			for (i = 2; i < l; i += 6) {
				shape.bezierCurveTo(segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5]);
			}
			if (segment.closed) {
				shape.closePath();
			}
		}

		shape.endFill();
	}


	killShape(shape) {
		shape.graphics.clear();
		shape.graphics.destroy();
		shape.completionTween.kill();
		shape.points = null;
		this.shapes.splice(this.shapes.indexOf(shape), 1);
	}

}
